import React, { useState, useEffect } from "react";

import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";
import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { ReactComponent as InfiniteSVG } from "../../../assets/infinite.svg";
import { OPContainer, OPWrapper, AutoConfig } from "../settings/SettingsStyled";
import {
  Row,
  Column,
  InputBox,
  InputSBox,
  InputM,
  Text,
  PlayBtn,
  BackBtn,
  Btn,
  Balance,
  Switch,
} from "./AutoStyled";

import useBetOperations from "../../bets";
import currencies from "../../helpers/getCurrency";
import { logger }  from '../../helpers/logger'

export default ({
  handleAbove,
  handleAutoSelect,
  bet,
  autoConfigs,
  handleAutoRollLogic,
  handleBombs,
  bombs,
  userInfo,
  handleNotification,
  handleAboveAnim,
  aboveAnim,
  userSettings,
  audio,
}) => {
  const { minBet, maxBet, precision, curr } = userInfo;
  const [onLossAnim, setOnLossAnim] = useState("");
  const [onWinAnim, setOnWinAnim] = useState("");

  const [plusPress, setPlusPress] = useState(false);
  const [minusPress, setMinusPress] = useState(false);
  const [playA, setPlayA] = useState(false);
  const [backA, setBackA] = useState(false);

  const [betInAuto, setbetInAuto] = useState(bet || "");
  const [inputBet, setinputBet] = useState(betInAuto);
  const [
    ubet,
    plus,
    minus,
    ,
    ,
    handleButtonPress,
    handleButtonRelease,
  ] = useBetOperations(
    betInAuto,
    userSettings.volume,
    userSettings.sound,
    handleNotification,
    minBet,
    maxBet,
    curr,
    precision
  );

  useEffect(() => {
    setbetInAuto(ubet);
    setinputBet(ubet);
  }, [ubet]);
  const [infinite, setInfinite] = useState(true);

  const [numberOfBets, setnumberOfBets] = useState("0");
  const [onWinReset, setonWinReset] = useState("1");
  const [onWinPercent, setonWinPercent] = useState("0");
  const [onLossReset, setonLossReset] = useState("1");
  const [onLossPercent, setonLossPercent] = useState("0");
  const [stopOnProfit, setstopOnProfit] = useState("0");
  const [stopOnLoss, setstopOnLoss] = useState("0");

  const max = maxBet;
  const min = minBet;

  useEffect(() => {
    setnumberOfBets(autoConfigs.numberOfBets);
    setonWinReset(autoConfigs.onWinReset);
    setonWinPercent(autoConfigs.onWinPercent);
    setonLossReset(autoConfigs.onLossReset);
    setonLossPercent(autoConfigs.onLossPercent);
    setstopOnProfit(autoConfigs.stopOnProfit);
    setstopOnLoss(autoConfigs.stopOnLoss);
  }, [autoConfigs]);

  const handleInput = (e) => {
    // const reg = /^-?\d+\.?\d*$/;
    const reg = /^\d*\.?\d*$/;

    const reg2 = /^[0-9]*$/;
    const name = e.target.name;
    if (
      (reg.test(e.target.value) && e.target.value >= 0) ||
      e.target.value === ""
    ) {
      switch (name) {
        case "numberOfBets":
          if (reg2.test(e.target.value)) setnumberOfBets(e.target.value);
          break;
        case "onWinPercent":
          setonWinReset("0");
          setonWinPercent(e.target.value);
          break;
        case "onLossPercent":
          setonLossReset("0");
          setonLossPercent(e.target.value);
          break;
        case "stopOnProfit":
          setstopOnProfit(e.target.value);
          break;
        case "stopOnLoss":
          setstopOnLoss(e.target.value);
          break;
        case "numberOfMines":
          if (reg2.test(e.target.value)) {
            handleBombs(e.target.value);
          }
          break;
        default:
          if (
            (reg.test(e.target.value) && e.target.value >= 0) ||
            e.target.value === ""
          ) {
            logger.log(name);
          }
          break;
      }
    }
  };

  const handleBet = (q) => {
    const e = q.target.value;
    // const reg = /^-?\d+\.?\d*$/;
    const reg = /^\d*\.?\d*$/;

    if (reg.test(e) || e === "") {
      setinputBet(e);
    }
  };
  const handleBlur = (e) => {
    const n = e.target.value;
    if (n < min || n === "") {
      setbetInAuto(min.toFixed(precision));
      setinputBet(min.toFixed(precision));
      handleNotification(`Minimum stake limit is ${min.toFixed(precision)} ${curr}`);
    } else if (n >= max) {
      setbetInAuto(max.toFixed(precision));
      setinputBet(max.toFixed(precision));
      handleNotification(`Maximum stake limit is ${max.toFixed(precision)} ${curr}`);
    } else {
      setbetInAuto((+n).toFixed(precision));
      setinputBet((+n).toFixed(precision));
    }
  };
  const stopOnLossBlur = (e) => {
    const n = e.target.value;
    setstopOnLoss((+n).toFixed(precision));
  };
  const stopOnProfitBlur = (e) => {
    const n = e.target.value;
    setstopOnProfit((+n).toFixed(precision));
  };
  const onWinPercentBlur = (e) => {
    const n = e.target.value;
    setonWinPercent(+n);
  };
  const onLossPercentBlur = (e) => {
    const n = e.target.value;
    setonLossPercent(+n);
  };
  const handleMineBlur = (e) => {
    const n = e.target.value;
    if (n <= 0 || n === "") {
      handleBombs(1);
      handleNotification("Minimum number of mines is 1");
    } else if (n >= 25) {
      handleBombs(24);
      handleNotification("Maximum number of mines is 24");
    } else {
      handleBombs(n);
    }
  };
  const handleNumBetBlur = (e) => {
    const n = e.target.value;
    if (n > 1000) {
      setnumberOfBets(1000);
      handleNotification("Maximum number of bets is 1000");
      setInfinite(false);
    } else if (n === "" || n === "0") {
      setnumberOfBets("");
      setInfinite(true);
    } else {
      setnumberOfBets(n);
      setInfinite(false);
    }
  };

  const nextStep = () => {
    handleAutoSelect(true);
    setTimeout(() => {
      handleAbove(false);
    }, 400);
    handleAutoRollLogic([
      betInAuto,
      max,
      onLossReset,
      onLossPercent,
      onWinReset,
      onWinPercent,
      stopOnLoss,
      stopOnProfit,
      numberOfBets,
    ]);
  };

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  const [soundPlayed, setSoundPlayed] = useState(false);

  return (
    <OPContainer aboveAnim={aboveAnim}>
      <OPWrapper>
        <AutoConfig aboveAnim={aboveAnim}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <form autoComplete="off">
              <Row>
                <Column>
                  <Text>Number Of Mines</Text>
                  <InputM
                    name="numberOfMines"
                    type="text"
                    onChange={handleInput}
                    placeholder={bombs}
                    value={bombs}
                    onBlur={handleMineBlur}
                  />
                </Column>
                <Column>
                  <Text>Number Of Bets</Text>
                  <InputM
                    data-autocomplete
                    name="numberOfBets"
                    type="text"
                    onChange={handleInput}
                    placeholder={
                      numberOfBets !== "0" && numberOfBets !== ""
                        ? numberOfBets
                        : ""
                    }
                    value={
                      numberOfBets !== "0" && numberOfBets !== ""
                        ? numberOfBets
                        : ""
                    }
                    onBlur={handleNumBetBlur}
                    onFocus={() => setInfinite(false)}
                  />
                  {(numberOfBets === "" || numberOfBets === "0") && infinite ? (
                    <InfiniteSVG className="infinite" />
                  ) : null}
                </Column>
              </Row>
              <Text>On Win</Text>
              <InputBox>
                <Switch
                  winAnim={onWinAnim}
                  data-testid="test"
                  active={onWinReset === "1"}
                  onClick={() => {
                    setonWinReset("1");
                    setOnWinAnim("1");
                    onWinReset !== "1" && audio.switch();
                  }}
                >
                  Reset
                </Switch>
                <Switch
                  winAnim={onWinAnim}
                  id="onwinincrease"
                  active={onWinReset !== "1"}
                  onClick={() => {
                    setonWinReset("0");
                    setOnWinAnim("0");
                    onWinReset === "1" && audio.switch();
                  }}
                >
                  Increase By
                </Switch>
                <InputSBox>
                  <input
                    name="onWinPercent"
                    maxLength="4"
                    placeholder={onWinPercent}
                    value={onWinPercent}
                    onChange={handleInput}
                    onBlur={onWinPercentBlur}
                  />
                  %
                </InputSBox>
              </InputBox>
              <Text>On Loss</Text>
              <InputBox>
                <Switch
                  active={onLossReset === "1"}
                  onClick={() => {
                    setonLossReset("1");
                    setOnLossAnim("1");
                    onLossReset !== "1" && audio.switch();
                  }}
                  lossAnim={onLossAnim}
                >
                  Reset
                </Switch>
                <Switch
                  id="onlossincrease"
                  active={onLossReset !== "1"}
                  onClick={() => {
                    setonLossReset("0");
                    setOnLossAnim("0");
                    onLossReset === "1" && audio.switch();
                  }}
                  lossAnim={onLossAnim}
                >
                  Increase By
                </Switch>
                <InputSBox>
                  <input
                    name="onLossPercent"
                    maxLength="4"
                    value={onLossPercent}
                    onChange={handleInput}
                    onBlur={onLossPercentBlur}
                  />
                  %
                </InputSBox>
              </InputBox>
              <Row>
                <Column>
                  <Text>Stop On Profit</Text>
                  <Balance className="inputM">
                    <input
                      name="stopOnProfit"
                      maxLength="11"
                      value={stopOnProfit}
                      onChange={handleInput}
                      onBlur={stopOnProfitBlur}
                    />
                 <span>{currencies[curr]}</span>
                  </Balance>
                </Column>
                <Column>
                  <Text>Stop On Loss</Text>
                  <Balance className="inputM">
                    <input
                      maxLength="11"
                      name="stopOnLoss"
                      value={stopOnLoss}
                      onBlur={stopOnLossBlur}
                      onChange={handleInput}
                    />
                     <span>{currencies[curr]}</span>
                  </Balance>
                </Column>
              </Row>
              <Row>
                <Btn
                  minusPress={minusPress}
                  onClick={minus}
                  onTouchStart={() => {
                    setMinusPress(true);
                    handleButtonPress("acceleratableMinus");
                  }}
                  onTouchEnd={() => {
                    setMinusPress(false);
                    handleButtonRelease();
                  }}
                  onMouseDown={() => {
                    setMinusPress(true);
                    handleButtonPress("acceleratableMinus");
                  }}
                  onMouseUp={() => {
                    setMinusPress(false);
                    handleButtonRelease();
                  }}
                  onMouseLeave={() => {
                    setMinusPress(false);
                    handleButtonRelease();
                  }}
                >
                  <MinusSVG />
                </Btn>
                <Balance>
                  <input
                    type="text"
                    maxLength="10"
                    value={inputBet}
                    onChange={handleBet}
                    onBlur={handleBlur}
                  />
                  <span>{currencies[curr]}</span>
                </Balance>

                <Btn
                  plusPress={plusPress}
                  onClick={plus}
                  onTouchStart={() => {
                    setPlusPress(true);
                    handleButtonPress("acceleratablePlus");
                  }}
                  onTouchEnd={() => {
                    setPlusPress(false);
                    handleButtonRelease();
                  }}
                  onMouseDown={() => {
                    setPlusPress(true);
                    handleButtonPress("acceleratablePlus");
                  }}
                  onMouseUp={() => {
                    setPlusPress(false);
                    handleButtonRelease();
                  }}
                  onMouseLeave={() => {
                    setPlusPress(false);
                    handleButtonRelease();
                  }}
                >
                  <PlusSVG />
                </Btn>
              </Row>
            </form>
            <PlayBtn
              isDisabled={soundPlayed}
              playA={playA}
              onClick={() => {
                setAnimation(playA, setPlayA);
                audio.confirm();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnim(false);
                  nextStep();
                }, 100);
              }}
            >
              OK
            </PlayBtn>
            <BackBtn
              backA={backA}
              isDisabled={soundPlayed}
              onClick={() => {
                setAnimation(backA, setBackA);
                audio.goBack();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnim(false);
                  handleAutoSelect(false);
                  setTimeout(() => {
                    handleAbove(false);
                  }, 500);
                }, 100);
              }}
            >
              Back
            </BackBtn>
          </div>
        </AutoConfig>
      </OPWrapper>
    </OPContainer>
  );
};
